/**
 * This exception is thrown when a request is made with a hash that is itself invalid.
 */
export class InvalidHashException extends Error {}

/**
 * This exception is thrown when an attempt is made to invite a new representative once the limit is already reached.
 */
export class RepresentativeLimitReachedException extends Error {}

/**
 * This exception is thrown when the business email provided already exists.
 */
export class BusinessEmailAlreadyExists extends Error {}

/**
 * This exception is thrown when the business is frozen.
 */
export class BusinessFrozenException extends Error {}

/**
 * This exception is thrown when already exists a Business Unification from one or more
 * businesses selected in creation step
 */
export class BusinessUnificationAlreadyExistsException extends Error {}

/**
 * This exception is thrown when one or more businesses selected to create a
 * Business Unification are not from the same country
 */
export class BusinessUnificationNotFromSameCountryException extends Error {}

/**
 * This exception is thrown when only one business is selected to create a new Business Unification
 */
export class BusinessUnificationNeedsMultipleBusinessesException extends Error {}

/**
 * This exception is thrown when a representative is invited to an inactive business that has no printers.
 */
export class CannotInviteToInactiveBusinessException extends Error {}

/**
 * This exception is thrown when the business doesn't has any active VIP coupon.
 */
export class CouponVIPNotFoundException extends Error {}
